import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ProjectComment } from '../../../../data/project/project-comment';
import { Project } from '../../../../data/project/project';
import { User } from 'projects/core/src/lib/login/data/user';
import { ProjectHolder } from '../../../../interfaces/project-holder';
import { ProjectService } from '../../../../data/project/project.service';

@Component({
    selector: 'app-reply-comment',
    templateUrl: './reply-comment.component.html',
    styleUrls: ['./reply-comment.component.scss']
})
export class ReplyCommentComponent implements OnInit, AfterViewInit {
    @Input()
    comment: ProjectComment;

    project: Project

    showInput = false;

    @Input()
    users: User[];

    itemDescription: string;

    @Output() closeAction = new EventEmitter<void>();

    @ViewChild('replyCommentTextArea', { static: true })
    replyCommentTextArea: ElementRef;

    loadingSpinner = false;

    constructor(
        protected projectHolder: ProjectHolder,
        protected projectService: ProjectService,
    ) {
        this.project = this.projectHolder.project
    }

    ngOnInit(): void {
    }

    showInputItem() {
        this.showInput = true;
        this.closeAction.emit();
    }

    ngAfterViewInit() {
        (this.replyCommentTextArea.nativeElement as HTMLElement).focus();
    }

    addComment() {
        this.loadingSpinner = true;

        const commentData: ProjectComment = {
            id: null,
            text: this.itemDescription,
            parentComment: this.comment
        }

        this.projectService.addComment(this.project.id, commentData).subscribe(comment => {
            if (!this.comment.replies) {
                this.comment.replies = [];
            }
            this.comment.replies.push(comment)
            this.itemDescription = '';
            this.loadingSpinner = false;
            this.closeAction.emit();
        }, error => {
            this.loadingSpinner = false;
        })
    }

    hideInputItem() {
        this.itemDescription = ''
        this.closeAction.emit();
    }

    onMentionSelect(user: User) {
        return '@' + user.username + ' ';
    }


}
